/**
 * Anchor for the sale/sharing opt-out control on the privacy settings page.
 *
 * The "Your Privacy Choices" page deep-links signed-in members straight to
 * the control, so the id and the link live together and cannot drift apart.
 */
export const SALE_OR_SHARING_OPT_OUT_SECTION_ID = 'do-not-sell-or-share';

/**
 * Deep link to the opt-out control for a signed-in member.
 */
export const MEMBER_PRIVACY_OPT_OUT_LINK = `/app/settings/privacy#${SALE_OR_SHARING_OPT_OUT_SECTION_ID}`;
